import { useForm } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LoaderCircle } from "lucide-react";

export function ForgotPasswordForm() {
  const { data, setData, post, processing } = useForm({
    email: "",
  });

  function logIn(e: React.SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();
    post("/passwords");
  }

  return (
    <div className="flex flex-col gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-xl">Forgot your password?</CardTitle>
          <CardDescription>
            Enter your email and we'll send you a link to reset your password.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={logIn}>
            <div className="grid gap-6">
              <div className="grid gap-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  name="email"
                  required
                  value={data.email}
                  onChange={(e) => setData("email", e.target.value)}
                />
              </div>
              <Button type="submit" className="w-full" disabled={processing}>
                {processing && <LoaderCircle className="animate-spin" />}
                Reset your password
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
